import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CountUpDirective } from 'ngx-countup';

import { VbUiKpiComponent } from './VbUiKpi.Component';

const components = [
	VbUiKpiComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		CountUpDirective
	]
})
export class KpiModule {}
